import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { getFestivals, getProgram, getProgramEvents } from '../../data/loadData'
import { dateRange, parseDay, upper } from '../../data/dates'
import './FestivalSection.css'

function edition(festival) {
    const match = String(festival.name || '').match(/^(\d+)\./)
    return match ? match[1] : ''
}

function FestivalCard({ festival, featured }) {
    const [broken, setBroken] = useState(false)
    const number = edition(festival)
    const days = (getProgram(festival.id).dates || []).map(parseDay).filter((day) => day.day)
    const range = dateRange(days, { withYear: false })
    const count = getProgramEvents(festival.id).length
    const poster = festival.poster || `images/festivals/${festival.id}/${festival.logo || 'logo.png'}`

    return (
        <li className={`arc-item${featured ? ' arc-item--featured' : ''}`}>
            <Link to={`/festival?f=${festival.id}`} className='arc-card'>
                <div className='arc-frame'>
                    {broken ? (
                        <div className='arc-frame-empty' aria-hidden='true'>
                            <span>{number}</span>
                            <small>{festival.id}</small>
                        </div>
                    ) : (
                        <>
                            <img className='arc-frame-glow' src={poster} alt='' aria-hidden='true' loading='lazy' />
                            <img
                                className='arc-frame-img'
                                src={poster}
                                alt={`${festival.name} afişi`}
                                loading='lazy'
                                onError={() => setBroken(true)}
                            />
                        </>
                    )}
                </div>
                <div className='arc-caption'>
                    {number ? <span className='arc-num' aria-hidden='true'>{number}</span> : null}
                    <div className='arc-caption-text'>
                        <h3 className='arc-year'>
                            <span className='sr-only'>{festival.name}, </span>
                            {festival.id}
                        </h3>
                        {range || count ? (
                            <p className='arc-meta'>
                                {[range, count ? `${count} etkinlik` : ''].filter(Boolean).join(' · ')}
                            </p>
                        ) : null}
                    </div>
                    <span className='arc-arrow' aria-hidden='true'>→</span>
                </div>
            </Link>
        </li>
    )
}

export default function FestivalSection() {
    const festivals = [...getFestivals()].sort((a, b) => b.id - a.id)
    const first = festivals[festivals.length - 1]

    return (
        <section className='arc' lang='tr' aria-labelledby='arc-heading'>
            <div className='container'>
                <header className='arc-head'>
                    <p className='arc-eyebrow'>Arşiv</p>
                    <h2 className='arc-heading' id='arc-heading'>{upper('Festivallerimiz')}</h2>
                    {first ? (
                        <p className='arc-lede'>
                            {first.id} yılından bu yana Ankara sahnelerinde {festivals.length} festival.
                            Programlarına, oyunlarına ve afişlerine buradan ulaşabilirsiniz.
                        </p>
                    ) : null}
                </header>

                <ul className='arc-grid'>
                    {festivals.map((festival, index) => (
                        <FestivalCard key={festival.id} festival={festival} featured={index === 0} />
                    ))}
                </ul>
            </div>
        </section>
    )
}
